import {
  DATA_TABLE_SOURCE_MARKETING_PARTNER_LISTINGS,
} from 'common/dataTableConstants';

import {
  dataTableGetBranchParams,
  actionDataTableLoadItemsIfNotFullyLoaded,
  actionInitializeDataTableState,
} from 'client/helpers/dataTables';

export default async function getMarketingPartnerListings(
  { state, apiClient },
  { landlordId }
) {
  const dataTableSettings = {
    dataSource: DATA_TABLE_SOURCE_MARKETING_PARTNER_LISTINGS,
    viewId: `landlord-${landlordId}`,
    count: 100,
    filter: {
      'listings.landlordId': landlordId,
    },
    sort: {
      'marketingPartnerListings.createdDate': 'desc',
    },
  };

  actionInitializeDataTableState({ state, apiClient }, dataTableSettings);
  await actionDataTableLoadItemsIfNotFullyLoaded({ state, apiClient }, dataTableSettings);

  const branchParams = dataTableGetBranchParams(dataTableSettings)();
  const watcher = state.watch(branchParams);
  const { items } = watcher.get();
  watcher.release();

  return items;
}
